import React, { createContext, useState, useContext, useEffect } from 'react';
import axios from 'axios';
import { getToken } from '../utils/auth';

// Create the context
const ConnectionContext = createContext();

// Create a provider component
export const ConnectionProvider = ({ children }) => {
  const [connections, setConnections] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  // Fetch connections data
  const handleConnections = async () => {
    try {
      setLoading(true);
      const token = getToken();
      const response = await axios.get(
        `${process.env.REACT_APP_URL}/api/connection/all`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "multipart/form-data",
          },
        }
      );
      setConnections(response.data.data.connectionList);
      setLoading(false);
    } catch (error) {
      console.log("Failed Fetching Connections", error);
      setError(error);
      setLoading(false);
    }
  };
useEffect(()=>{
    handleConnections()
},[])
  // Provide the context value to children components
  return (
    <ConnectionContext.Provider value={{ connections, handleConnections, loading, error }}>
      {children}
    </ConnectionContext.Provider>
  );
};

// Custom hook to use the connection context
export const useConnections = () => {
  return useContext(ConnectionContext);
};
